<template>
    <div class="filter-bar" style="padding-top: 0">
        <div class="d-flex align-items-center filter-title">
            <!-- <CRow class="filter pr-0"> -->
            <h5 class="m-0"><strong>Filter</strong></h5>
            <div class="ml-auto">
                <!-- <CButton color="success" size="sm" class="filter-btn apply" @click="applyFilterHandler"
                    :disabled="disableApplyBtn">Apply</CButton> -->
                <CButton color="danger" size="sm" class="filter-btn clear" @click="clearFilterHandler"
                    :disabled="selectedClients.length === 0 && selectedPrimaryCategories.length === 0 && selectedSecondaryCategories.length === 0 && selectedSubCategories.length === 0 && selectedVendors.length === 0">
                    Reset All
                </CButton>
            </div>
            <!-- </CRow> -->
        </div>
        <!--- <DateFilter
            class="mt-2"
            @invalidDate="disableApplyBtn = true"
            @getDate="
                (el) => {
                    disableApplyBtn = false;
                    selectedStartDate = el.startDate;
                    selectedEndDate = el.endDate;
                }
            "
        />-->
        <clientFilter v-if="isSysAdmin || isGroupAdmin" class="mt-3" :isMultiple="isMultiple" />
        <!-- <KeywordsFilter class="mt-3" :resetFilter="resetFilter" @getKeywords="(el) => (selectedKeywords = el)" /> -->
        <br /><br />
        <CategoriesFilter title="Primary Categories" :options="primaryCategories" @apply="applyFiltersForPrimary"
            @reset="resetFiltersForPrimary" :collapsedProp="primaryCategoriesCollapsed"
            :resetDisabled="resetDisabled.primaryCategories" />
        <hr />
        <CategoriesFilter title="Secondary Categories" :options="secondaryCategories" @apply="applyFiltersForSecondary"
            @reset="resetFiltersForSecondary" :resetDisabled="resetDisabled.secondaryCategories" />
        <hr />
        <CategoriesFilter title="Sub Categories" :options="subCategories" @apply="applyFiltersForSub"
            @reset="resetFiltersForSub" :resetDisabled="resetDisabled.subCategories" />
        <hr />
        <CategoriesFilter title="Vendors" :options="vendors" @apply="applyFiltersForVendor"
            @reset="resetFiltersForVendor" :resetDisabled="resetDisabled.vendors" />
    </div>
</template>

<script>
import CategoriesFilter from "./CategoriesFilter";
// import DateFilter from "./date";
// import KeywordsFilter from "./keywords";
import clientFilter from "./clientFilter";
import { storeData } from "../../store";
import gql from "graphql-tag";
import { getSelectedClients } from "../../store";
import { mapState, mapMutations } from 'vuex';

export default {
    props: {
        offset: Number,
        isMultiple: {
            type: Boolean,
            default: true,
        }
    },
    data() {
        return {
            primaryCategories: [],
            secondaryCategories: [],
            subCategories: [],
            vendors: [],
            selectedPrimaryCategories: [],
            selectedSecondaryCategories: [],
            selectedSubCategories: [],
            selectedVendors: [],
            primaryCategoriesCollapsed: false,
            resetDisabled: {
                primaryCategories: true,
                secondaryCategories: true,
                subCategories: true,
                vendors: true,
            }
        };
    },
    watch: {
        async offset() {
            await this.fetchData(false);
        },
        async selectedClients() {
            await this.fetchData(true);
        },
        async statusFilter() {
            await this.fetchData(true);
        },
    },
    components: {
        CategoriesFilter,
        // DateFilter,
        // KeywordsFilter,
        clientFilter,
    },
    computed: {
        ...mapState(['statusFilter']),
        isSysAdmin() {
            return storeData.currentUserDetails.role.name === "sys_admin";
        },
        isGroupAdmin() {
            return storeData.currentUserDetails.role.name === "group_admin";
        },
        selectedClients() {
            return getSelectedClients();
        }
    },
    methods: {
        ...mapMutations(['setStatusFilter']),
        async applyFiltersForPrimary(categories) {
            this.selectedPrimaryCategories = categories.map(item => item.id);
            await this.fetchData(true);
            this.resetDisabled = {
                ... this.resetDisabled,
                primaryCategories: false,
            };
        },
        async resetFiltersForPrimary() {
            this.selectedPrimaryCategories = [];
            await this.fetchData(true);
            this.resetDisabled = {
                ... this.resetDisabled,
                primaryCategories: true,
            };
        },
        async applyFiltersForSecondary(categories) {
            this.selectedSecondaryCategories = categories.reduce((acc, cat) => {
                if (typeof cat.id === "string" && cat.id.indexOf(",") > -1) {
                    return [...acc, ...cat.id.split(",").map(id => Number(id))];
                }
                return [...acc, cat.id];
            }, []);

            await this.fetchData(true);
            this.resetDisabled = {
                ... this.resetDisabled,
                secondaryCategories: false,
            };
        },
        async resetFiltersForSecondary() {
            this.selectedSecondaryCategories = [];
            await this.fetchData(true);
            this.resetDisabled = {
                ... this.resetDisabled,
                secondaryCategories: true,
            };
        },
        async applyFiltersForSub(categories) {
            this.selectedSubCategories = categories.reduce((acc, cat) => {
                if (typeof cat.id === "string" && cat.id.indexOf(",") > -1) {
                    return [...acc, ...cat.id.split(",").map(id => Number(id))];
                }
                return [...acc, cat.id];
            }, []);

            await this.fetchData(true);
            this.resetDisabled = {
                ... this.resetDisabled,
                subCategories: false,
            };
        },
        async resetFiltersForSub() {
            this.selectedSubCategories = [];
            await this.fetchData(true);
            this.resetDisabled = {
                ... this.resetDisabled,
                subCategories: true,
            };
        },
        async applyFiltersForVendor(categories) {
            this.selectedVendors = categories.map(item => item.id);
            await this.fetchData(true);
            this.resetDisabled = {
                ... this.resetDisabled,
                vendors: false,
            };
        },
        async resetFiltersForVendor() {
            this.selectedVendors = [];
            await this.fetchData(true);
            this.resetDisabled = {
                ... this.resetDisabled,
                vendors: true,
            };
        },
        async fetchData(resetPagination = true) {
            this.$emit("updateSpinner", true);
            const tempSelectedPrimaryCategories = this.$store.state.tempSelectedPrimaryCategories;
            if (tempSelectedPrimaryCategories.length > 0) {
                this.selectedPrimaryCategories = [...this.selectedPrimaryCategories, ...tempSelectedPrimaryCategories];
                this.primaryCategoriesCollapsed = true;
                this.$store.commit("set", ["tempSelectedPrimaryCategories", []]);
            }
            await this.$apollo
                .mutate({
                    mutation: SPENDMD_ALL_DATA,
                    variables: {
                        primeCategories: this.selectedPrimaryCategories,
                        secondaryCategories: this.selectedSecondaryCategories,
                        subCategories: this.selectedSubCategories,
                        vendors: this.selectedVendors,
                        offset: resetPagination ? 0 : this.offset,
                        order: "desc",
                        clients: this.selectedClients,
                        status: this.statusFilter,
                    },
                })
                .then((res) => {
                    const rawCategories = res.data.spendmd_db_get_categories;
                    this.primaryCategories = (rawCategories[0].category_result.primary_categories || []).map(([id, name]) => ({
                        id, name, checked: true
                    }));

                    this.secondaryCategories = (rawCategories[0].category_result.secondary_categories || []).map(([id, name]) => ({
                        id, name, checked: true
                    }));

                    this.subCategories = (rawCategories[0].category_result.sub_categories || []).map(([id, name]) => ({
                        id, name, checked: true
                    }));

                    this.vendors = (rawCategories[0].category_result.vendor || []).map(([id, name]) => ({
                        id, name, checked: true
                    }));

                    this.$emit("updateChartData", {
                        spendmd_db_spend_by_vendor_mapped_aggregate: res.data.spendmd_db_spend_by_vendor_mapped_aggregate,
                        spendmd_db_contract_spend_by_vendor_aggregate: res.data.spendmd_db_contract_spend_by_vendorv2_aggregate,
                        spendmd_db_po_spend_above_ap_aggregate: res.data.spendmd_db_po_spend_above_ap_aggregate,
                        prime_categories: this.primaryCategories.map(item => item.id),
                        secondary_categories: this.secondaryCategories.map(item => item.id),
                        sub_categories: this.subCategories.map(item => item.id),
                        vendors: this.vendors.map(item => item.id),
                    }, resetPagination);
                }).catch((err) => {
                    console.log(err);
                });

            this.$emit("updateSpinner", false);
        },
        applyFilterHandler() {
        },
        clearFilterHandler() {
            this.selectedPrimaryCategories = [];
            this.selectedSecondaryCategories = [];
            this.selectedSubCategories = [];
            this.selectedVendors = [];
            this.$store.commit('set', ['selectedClientList', []]);
            this.setStatusFilter(0);
            this.$emit("resetFilter");

            this.resetDisabled = {
                primaryCategories: true,
                secondaryCategories: true,
                subCategories: true,
                vendors: true,
            };
        },
    },
    async mounted() {
        await this.fetchData();
    },
};

const SPENDMD_ALL_DATA = gql`
    query (
        $primeCategories: json
        $secondaryCategories: json
        $subCategories: json
        $vendors: json
        $offset: Int
        $order: String
        $clients: json
        $status: Int
    ) {
        spendmd_db_get_categories(
            args: {
                clients: $clients,
                prime_categories: $primeCategories,
                secondary_categories: $secondaryCategories,
                status_selected: $status,
                sub_categories: $subCategories,
                vendors: $vendors
            }) {
                category_result
            }
        spendmd_db_spend_by_vendor_mapped_aggregate(
            args: {
                clients: $clients,
                limit_value: 10,
                offset_value: $offset,
                order_value: $order,
                prime_categories: $primeCategories,
                secondary_categories: $secondaryCategories,
                status_selected: $status,
                sub_categories: $subCategories,
                vendors: $vendors
            }) {
                aggregate {
                    max {
                        total_po_spend
                        total_non_po_spend
                        vendor_count
                        ap_end
                        ap_start
                        po_end
                        po_start
                        ap_note
                        po_note
                    }
                    sum {
                        po_spend
                        non_po_spend
                        total_non_po_spend
                        total_po_spend
                        vendor_count
                    }
                }
                nodes {
                    vendor_source
                    vendor_id
                    keywords
                    ap_start
                    ap_end
                    po_start
                    po_end
                    status
                    po_spend
                    non_po_spend
                    mapped_spend
                }
            }
        spendmd_db_contract_spend_by_vendorv2_aggregate(
            args: {
                clients: $clients,
                limit_value: 10,
                offset_value: $offset,
                order_value: $order,
                prime_categories: $primeCategories,
                secondary_categories: $secondaryCategories,
                status_selected: $status,
                sub_categories: $subCategories,
                vendors: $vendors
            }) {
                aggregate {
                    sum {
                        contract_spend
                        non_contract_spend
                    }
                }
                nodes {
                    vendor_source
                    vendor_id
                    contract_spend
                    non_contract_spend
                }
            }
        spendmd_db_po_spend_above_ap_aggregate(
            args: {
                clients: $clients
            }) {
                aggregate {
                    max {
                        total_rows
                    }
                }
                nodes {
                    vendor_source
                    vendor_id
                    po_spend
                    ap_spend
                }
            }
        }
    `;
</script>

<style scoped>
.c-app:not(.c-legacy-theme):not(.c-dark-theme) .card {
    padding: 20px;
}

.filter-title {
    width: 100%;
    padding-top: 32px;
    padding-bottom: 16px;
}

.filter-bar {
    background-color: white;
    padding: 0 35px 16px;
    overflow-y: scroll;
}

.filter-bar .keywords-label {
    float: right;
}

::-webkit-scrollbar {
    width: 5px;
}

::-webkit-scrollbar-thumb {
    background: #888;
}

::-webkit-scrollbar-thumb:hover {
    background: #555;
}

.filter-btn {
    padding: 8px 13px;
    color: white;
    float: right;
    margin: auto 2px;
}

.filter-btn:disabled {
    cursor: not-allowed;
    pointer-events: all !important;
}

.btn-success:focus {
    background-color: #2eb85c !important;
    color: white;
}

.btn-danger:focus {
    background-color: #e03232 !important;
    color: white;
}
</style>
